module.exports = __webpack_public_path__ + "f5c7b676f22b54dda222e356513bb454.png";